import { render, staticRenderFns } from "./gift-tip.vue?vue&type=template&id=3cd409de&scoped=true&"
import script from "./gift-tip.vue?vue&type=script&lang=js&"
export * from "./gift-tip.vue?vue&type=script&lang=js&"
import style0 from "./gift-tip.vue?vue&type=style&index=0&id=3cd409de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd409de",
  null
  
)

export default component.exports